/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const deleteApiProjectstatusesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const deleteApiProjectstatusesId200Schema = z.any();

export const deleteApiProjectstatusesIdMutationResponseSchema = z.lazy(
  () => deleteApiProjectstatusesId200Schema,
);
